import ImagesSellWithUsBannerBgPng from '@/public/images/sell-with-us-banner/bg.png';
import ImagesSellWithUsBannerColorfulBackgroundIpadMockupTemplatePng from '@/public/images/sell-with-us-banner/colorful-background-ipad-mockup-template.png';
import ImagesSellWithUsBannerSellWithUsJpg from '@/public/images/sell-with-us-banner/sell-with-us.jpg';
import ImagesSellWithUsBannerSellWithUsNewBannerWebp from '@/public/images/sell-with-us-banner/sell-with-us-new-banner.webp';

export {
  ImagesSellWithUsBannerBgPng,
  ImagesSellWithUsBannerColorfulBackgroundIpadMockupTemplatePng,
  ImagesSellWithUsBannerSellWithUsJpg,
  ImagesSellWithUsBannerSellWithUsNewBannerWebp,
};
